<ng-container>
    <div class="control-card-header">
        <div id="header">
            <ng-container i18n="@@migrationDialog_title"> Migrazione impianto</ng-container>
            <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
        </div>
    </div>

    <div class="control-card-content">

        <div id="messageDiv">
            <ng-container i18n="@@migrationDialog_text">Verso quale impianto desideri migrare gli utenti dell'impianto
                attuale? ({{originSerial}})</ng-container>
            <br>
            <input type="text" [(ngModel)]="destinationSerial" />
        </div>


        <a class="button user-add-button" (click)="beginMigration()" id="okButton">
            <ng-container i18n="@@migrationDialog_begin">Inizia migrazione</ng-container>
            <span>
                <fa-icon icon="check"></fa-icon>
            </span>
        </a>

    </div>

    <app-loading-screen #loader></app-loading-screen>

</ng-container>